import { render, staticRenderFns } from "./CurrencySetting.vue?vue&type=template&id=5530ff76&"
import script from "./CurrencySetting.vue?vue&type=script&lang=js&"
export * from "./CurrencySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports